import Swal from "sweetalert2";
import { Backdrop, CircularProgress } from "@mui/material";

const win: Window = window;

export const onShowAlerts = (
  alerts: string,
  callback?: (result: any) => void
) => {
  const alert = alerts.toLowerCase();
  Swal.fire({
    icon: "info",
    title: "Info",
    confirmButtonColor: "#7cd1f9",
    text: alert != "invalid jwt" ? alerts! : "Your session is ended.",
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      win.location.reload();
      if (callback) {
        callback(null);
      }
    }
  });
};

export const onShowLoading = (isShow: boolean = true) => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
    open={isShow}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
